import { render, staticRenderFns } from "./CategoryMain.vue?vue&type=template&id=54550456&"
import script from "./CategoryMain.vue?vue&type=script&lang=ts&"
export * from "./CategoryMain.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports